import { render, staticRenderFns } from "./TemporaryPassword.vue?vue&type=template&id=3536bd3d&scoped=true"
import script from "./TemporaryPassword.vue?vue&type=script&lang=js"
export * from "./TemporaryPassword.vue?vue&type=script&lang=js"
import style0 from "./TemporaryPassword.vue?vue&type=style&index=0&id=3536bd3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3536bd3d",
  null
  
)

export default component.exports